import { render } from "./CreateRecipe.vue?vue&type=template&id=c1856176&scoped=true"
import script from "./CreateRecipe.vue?vue&type=script&lang=js"
export * from "./CreateRecipe.vue?vue&type=script&lang=js"

import "./CreateRecipe.vue?vue&type=style&index=0&id=c1856176&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1856176"]])

export default __exports__